module.exports = __webpack_public_path__ + "img/feature1-1x.fd5d6c1.png";